export default __webpack_public_path__ + "static/media/Avatar-24.555f16fe.png";